import PropTypes from 'prop-types';
import React from 'react';

function PlayTriangle({ width = 11, height = 14, fill = '#fff', ...props }) {
  return (
    <svg
      width={width}
      height={height}
      {...props}
      viewBox="0 0 11 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polygon fill={fill} points="0,0 0,14 11,7"></polygon>
    </svg>
  );
}

PlayTriangle.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string,
};

export default PlayTriangle;
